export default __webpack_public_path__ + "static/media/clean.aef8cb05.svg";